import criarFinanceiro from './financeiro';

export default criarFinanceiro('RECEBER');
